import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// import CustomButtonWithStroke from './../../components/auth/AuthButton';
import '../../styles/Home.css';
import axios from 'axios';

const ReferralLink = () => {
    const navigate = useNavigate();
    const { userName, referrallink } = useParams();
    useEffect(() => {
        const redirectUrl = async () => {
            if (userName && referrallink) {
                await axios(
                    `${process.env.REACT_APP_BACKEND_URL}/api/referrals/${userName}/${referrallink}`).then((res) => {
                        navigate(`/register?referralCode=${res.data.referralCode}`);
                    }).catch((error) => {
                        console.error('Redirect failed:', error);
                        navigate('/'); // Fallback to home
                    });
            }
        }

        redirectUrl();
    }, [userName, referrallink, navigate]);

    return (
        <div className="home-container">
            Loading...
        </div>
    );
};

export default ReferralLink;